export type CampaignContactModel = {
  cache_key: number,
  id: number,
  campaign_id: number,
  contact_id: number,
  contact_type: string,
}

export type CampaignContactRequestOptions = {}

const state = {
  id: null,
  campaign_id: undefined,
  contact_id: undefined,
  contact_type: '',
}

export const requiredFields = [
  { key: 'campaign_id' },
  { key: 'contact_id' },
]

export default state
